import React from 'react';
import { Button, Header, Icon, Modal, Popup } from 'semantic-ui-react';
import InstrucaoSinistro from '../../../resources/docs/instrucao-sinistro/instrucao-sinistro';
import styled from 'styled-components';

const SpanWrapper = styled.span`
  color: ${props => props.theme.main.color};
  cursor: pointer;
  font-size: 14px
  font-weight: bold;
`;

const IconWrapper = styled(Icon)`
  color: #ffffff;
  background-color: ${props => props.theme.main.color} !important;
`;

interface ModalInstructionsProps {
  openModal: boolean;
  toggleOpen: () => void;
  toggleClose: () => void;
}
const ModalInstructions = (props: ModalInstructionsProps) => {
  const { openModal, toggleClose, toggleOpen } = props;
  return (
    <>
      <Modal open={openModal} onClose={toggleClose} onOpen={toggleOpen} style={{ zIndex: 1002 }}>
        <Modal.Header>
          <Header>Como abrir um sinistro</Header>
        </Modal.Header>
        <Modal.Content scrolling>
          <InstrucaoSinistro />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={toggleClose} color={'green'}>
            OK, Entendi
          </Button>
        </Modal.Actions>
      </Modal>

      <Popup
        trigger={
          <SpanWrapper onClick={toggleOpen}>
            <IconWrapper
              circular
              size={'small'}
              name={'info'}
              style={{ cursor: 'pointer', marginRight: '10px', fontSize: 14 }}
            />
            Como abrir um Sinistro:
          </SpanWrapper>
        }
        content={'Clique aqui para maiores informações sobre como abrir um sinistro'}
        position={'left center'}
      />
    </>
  );
};

export default ModalInstructions;
